import React from "react";

const WarningToast = ({ message }) => {
    return (
        <>
            <div className="alert-items-message flex">
                <div className="mt-1">
                    <i className="fas fa-exclamation-circle icon-message"></i>
                </div>
                <div className="alert-items-title ml-3">
                    <h3>Warning</h3>
                    <p>{message}</p>
                </div>
            </div>
        </>
    );
};

export default WarningToast;
